import React, { useState } from "react";
import closeDropdown from "../../assets/closeDropdown.svg";
import openDropdown from "../../assets/openDropdown.svg";

const SingleDropdown = (props) => {
  const {
    projectList,
    selectedOption,
    setSelectedOption,
    uniqueId,
    handleInitialData,
    setAccessErr,
  } = props;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleClick = (project) => {
    if (uniqueId === "taskExecution") {
      handleInitialData();
    }
    setSelectedOption((prev) => ({ ...prev, ...project }));
    setAccessErr("");
  };

  return (
    <div
      onClick={() => setIsDropdownOpen((prev) => !prev)}
      className={`relative border border-gray-200 ${
        uniqueId === "attendance" ? "rounded-full" : "rounded-[8px]"
      } h-12 bg-white p-4 w-full flex justify-between items-center gap-7`}
    >
      <div className="text-[14px] text-[#1C75BC]">
        {selectedOption.projectName || "Select Your Project"}
      </div>
      <div className="">
        {isDropdownOpen ? (
          <img src={closeDropdown} alt="" />
        ) : (
          <img src={openDropdown} alt="" />
        )}
      </div>
      {isDropdownOpen && (
        <div
          className={`absolute rounded-md border ${
            projectList && projectList.length > 5
              ? "h-60 overflow-y-scroll"
              : ""
          } border-gray-200 w-full bg-white p-2 py-0 top-[110%] left-0 z-20`}
        >
          {projectList &&
            projectList.map((i, index) => (
              <div
                onClick={() => handleClick(i)}
                key={i.projectId}
                className={`p-3 ${
                  index === projectList.length - 1 ? "" : "border-b"
                } border-gray-200 text-[14px]`}
              >
                {i.projectName}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default SingleDropdown;
